import { useTranslation } from 'next-i18next';
const SkipLink = () => {
  const {
    t
  } = useTranslation('layouts');
  return <a href="#main-content" className="skip-link" style={{
    position: 'absolute',
    left: '-9999px',
    top: 'auto',
    width: '1px',
    height: '1px',
    overflow: 'hidden'
  }} onFocus={e => {
    e.target.style.position = 'static';
    e.target.style.width = 'auto';
    e.target.style.height = 'auto';
  }} onBlur={e => {
    e.target.style.position = 'absolute';
    e.target.style.left = '-9999px';
    e.target.style.width = '1px';
    e.target.style.height = '1px';
  }}>
      {t('footer.navigation.skipToContent')}
    </a>;
};
export default SkipLink;